import useSWR, { SWRConfiguration } from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { addQueryParam } from 'shared/utils/add-query-param'
import { CourseId } from '../types/course-interface'
import { SearchLectureInterface } from '../types/search-lecture-interface'
import { MEMBERSHIP_COURSE_API } from './membership-api'

export const getSearchLecturesKey = ({
  courseId,
  search,
}: {
  courseId: CourseId
  search: string
}): string => {
  const searchParams = new URLSearchParams()

  addQueryParam(searchParams, 'searchBy', search)

  return `${MEMBERSHIP_COURSE_API}/${courseId}/lectures?${searchParams.toString()}`
}

interface UseSearchLecturesOptions {
  courseId: CourseId
  search: string
  config?: SWRConfiguration<SearchLectureInterface[], Error>
}

export const useSearchLectures = ({ courseId, search, config }: UseSearchLecturesOptions) => {
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    SearchLectureInterface[]
  >({
    method: RequestMethodsEnum.get,
  })

  return useSWR<SearchLectureInterface[]>(
    search ? getSearchLecturesKey({ courseId, search }) : null,
    fetcher,
    config,
  )
}
